import React, { useState } from "react";
import {
  View,
  ScrollView,
  TouchableOpacity,
  Text,
  SafeAreaView,
} from "react-native";
import BasicFilters from "./BasicFilters/BasicFilters";
import AdvanceFilters from "./AdvanceFilters/AdvanceFilters";
import InnerFilter from "./filterComponents/InnerFilter";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { styles } from "./filterStyles/filterStyles";
import ModalComponent from "../../ModalComponent";
import FeedIcons from "../../../assets/Icons/FeedIcons";
// Define the props interface
interface FiltersProps {
  isVisible: boolean;
  toggleModal: () => void;
  filters: any;
  setFilters: any;
  handleFiltersChange: any;
}

// Functional component
export default function Filters({
  isVisible,
  toggleModal,
  filters,
  setFilters,
  handleFiltersChange,
}: FiltersProps) {
  // console.log("filters parent component");

  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["Basic filters", "Advance filters"];
  const handleTabPress = (index: any) => {
    setActiveTab(index);
  };

  const [innerFilterVisible, setInnerFilterVisible] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState({
    label: "",
    value: "",
    component: null,
    filters: {},
    setFilters: {},
    name: "",
  });

  const handleBasicFilterPress = (
    label: string,
    value: string,
    component: any,
    name: string,
    filters: any,
    setFilters: any
  ) => {
    setSelectedFilter({ label, value, component, filters, setFilters, name });
    setInnerFilterVisible(true);
  };
  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View style={styles.modalBackground}>
        <View style={styles.modalContainer}>
          <View style={styles.modalWrap}>
            <TouchableOpacity onPress={toggleModal} style={styles.FilterHeader}>
              <View style={styles.FilterHeaderFlex}>
                <FeedIcons.BackIcon />
                <Text style={GlobalStyles.title1}>Dating Prefrences</Text>
              </View>
            </TouchableOpacity>
            <View style={styles.TabsWrapper}>
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={styles.tabsContainer}
              >
                {tabs.map((tab, index) => (
                  <TouchableOpacity
                    key={index}
                    style={[
                      styles.tab,
                      { borderBottomWidth: index === activeTab ? 1 : 0 },
                      {
                        borderBottomColor:
                          index === activeTab ? "#000000" : "blue",
                      }, // Change the color here
                    ]}
                    onPress={() => handleTabPress(index)}
                  >
                    <Text style={GlobalStyles.bodyText}>{tab}</Text>
                  </TouchableOpacity>
                ))}
              </ScrollView>
            </View>
            <View style={styles.container}>
              {activeTab === 0 ? (
                <>
                  <BasicFilters
                    onPress={handleBasicFilterPress}
                    filters={filters}
                    setFilters={setFilters}
                    toggleModal={toggleModal}
                  />
                </>
              ) : (
                <>
                  <AdvanceFilters
                    onPress={handleBasicFilterPress}
                    filters={filters}
                    setFilters={setFilters}
                    toggleModal={toggleModal}
                  />
                </>
              )}
            </View>
            {innerFilterVisible && (
              <InnerFilter
                isVisible={innerFilterVisible}
                // toggleModal={() => setInnerFilterVisible(false)}
                toggleModal={() => {
                  setInnerFilterVisible(false);
                }}
                innerFilterLabel={selectedFilter.label}
                filters={filters}
                setFilters={setFilters}
              >
                <View style={styles.InnerFilterWrap}>
                  {selectedFilter.component}
                </View>
              </InnerFilter>
            )}
          </View>
        </View>
      </View>
    </ModalComponent>
  );
}
